import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import './style.scss';

interface Props {
  className?: string;
  onClick: () => void;
}

const GoBackButton: React.FC<Props> = ({
  className,
  onClick,
}) => {
  const { t } = useTranslation();

  const classes = c('GoBackButton', className);

  return (
    <button
      type="button"
      className={classes}
      onClick={onClick}
    >
      {t('buttons.back')}
    </button>
  );
};

export default GoBackButton;
